// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Open Template ── */

/* Search + Sort toolbar */
.dp-ot__toolbar {
  display: flex;
  gap: var(--dp-spacing-xs);
  margin-bottom: var(--dp-spacing-sm);
  align-items: center;
}

.dp-ot__search-input {
  flex: 1;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  font-family: inherit;
  box-sizing: border-box;
  outline: none;
}

.dp-ot__search-input:focus {
  border-color: var(--dp-color-primary);
}

.dp-ot__sort-select {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  background: var(--dp-color-background);
  cursor: pointer;
  flex-shrink: 0;
}

.dp-ot__sort-select:focus {
  outline: none;
  border-color: var(--dp-color-primary);
}

/* ── Category chips ── */
.dp-ot__categories {
  display: flex;
  gap: 6px;
  margin-bottom: var(--dp-spacing-sm);
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
  -ms-overflow-style: none;
}

.dp-ot__categories::-webkit-scrollbar {
  height: 4px;
}

.dp-ot__categories::-webkit-scrollbar-thumb {
  background: var(--dp-color-border);
  border-radius: 2px;
}

.dp-ot__cat-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-full, 9999px);
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
  white-space: nowrap;
  background: var(--dp-color-background);
  color: var(--dp-color-text-secondary);
  transition: all 0.15s;
  flex-shrink: 0;
}

.dp-ot__cat-chip:hover {
  background: var(--dp-color-surface-hover);
  color: var(--dp-color-text);
}

.dp-ot__cat-chip--active {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border-color: var(--dp-color-primary);
}

.dp-ot__cat-chip--active:hover {
  background: var(--dp-color-primary-hover);
  color: var(--dp-color-text-inverse);
}

.dp-ot__cat-chip--favorites {
  border-color: #f9a825;
  color: #f57f17;
}

.dp-ot__cat-chip--favorites:hover {
  background: #fff8e1;
}

.dp-ot__cat-chip--favorites.dp-ot__cat-chip--active {
  background: #f9a825;
  border-color: #f9a825;
  color: #fff;
}

.dp-ot__cat-count {
  font-size: 10px;
  opacity: 0.8;
}

/* ── Section headers ── */
.dp-ot__section-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #f0f3f8;
  border-bottom: 1px solid var(--dp-color-border);
  font-size: 11px;
  font-weight: var(--dp-font-weight-bold);
  color: var(--dp-color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.dp-ot__section-icon {
  font-size: 12px;
}

/* ── Template card ── */
.dp-ot__list {
  display: flex;
  flex-direction: column;
}

.dp-ot__card {
  display: flex;
  align-items: flex-start;
  gap: var(--dp-spacing-xs);
  padding: var(--dp-spacing-sm) 10px;
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
  transition: background 0.12s;
}

.dp-ot__card:hover {
  background: var(--dp-color-surface);
}

.dp-ot__card-fav {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  font-size: 14px;
  line-height: 1;
  color: var(--dp-color-border);
  transition: color 0.15s;
  flex-shrink: 0;
  margin-top: 1px;
}

.dp-ot__card-fav:hover {
  color: #f9a825;
}

.dp-ot__card-fav--active {
  color: #f9a825;
}

.dp-ot__card-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.dp-ot__card-name {
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-bold);
  color: var(--dp-color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dp-ot__card-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.dp-ot__badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 9px;
  font-weight: var(--dp-font-weight-bold);
  padding: 1px 6px;
  border-radius: var(--dp-border-radius-sm);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.dp-ot__badge--category {
  background: #e3f2fd;
  color: #1565c0;
}

.dp-ot__badge--active {
  background: #e8f5e9;
  color: #2e7d32;
}

.dp-ot__badge--draft-status {
  background: #f5f5f5;
  color: #757575;
}

.dp-ot__badge--archived {
  background: #ffebee;
  color: #c62828;
}

.dp-ot__badge--published {
  background: #e8f5e9;
  color: #2e7d32;
}

.dp-ot__badge--draft {
  background: #fff3e0;
  color: #e65100;
}

.dp-ot__badge--locked {
  background: #fce4ec;
  color: #c62828;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.dp-ot__badge--locked .dp-ot__lock-icon {
  font-size: 10px;
}

.dp-ot__card-meta {
  font-size: 10px;
  color: var(--dp-color-text-secondary);
}

.dp-ot__card-actions {
  display: flex;
  gap: var(--dp-spacing-xs);
  flex-shrink: 0;
  align-items: flex-start;
  margin-top: 2px;
}

/* ── Buttons ── */
.dp-ot__btn {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
  transition: all 0.12s;
}

.dp-ot__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dp-ot__btn--edit {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border-color: var(--dp-color-primary);
}

.dp-ot__btn--edit:hover {
  background: var(--dp-color-primary-hover);
}

.dp-ot__btn--copy {
  background: var(--dp-color-surface);
  color: var(--dp-color-primary);
  border-color: var(--dp-color-primary);
}

.dp-ot__btn--copy:hover {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
}

.dp-ot__btn--primary {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border-color: var(--dp-color-primary);
}

.dp-ot__btn--primary:hover {
  background: var(--dp-color-primary-hover);
}

.dp-ot__btn--danger {
  background: #c62828;
  color: #fff;
  border-color: #c62828;
}

.dp-ot__btn--danger:hover {
  background: #b71c1c;
}

.dp-ot__btn--cancel {
  background: var(--dp-color-surface);
  color: var(--dp-color-text);
}

.dp-ot__btn--cancel:hover {
  background: var(--dp-color-surface-hover);
}

/* ── Messages / Status ── */
.dp-ot__error {
  padding: var(--dp-spacing-sm);
  background: #fde8e8;
  color: var(--dp-color-error);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  margin-bottom: var(--dp-spacing-sm);
}

.dp-ot__message {
  padding: var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  margin-bottom: var(--dp-spacing-sm);
}

.dp-ot__message--success { background: #e8f5e9; color: #2e7d32; }
.dp-ot__message--error { background: #fde8e8; color: #c62828; }

.dp-ot__loading,
.dp-ot__empty {
  text-align: center;
  padding: var(--dp-spacing-lg);
  color: var(--dp-color-text-secondary);
  font-size: var(--dp-font-size-sm);
}

/* ── Confirmation Dialog ── */
.dp-ot__confirm {
  background: #fff8e1;
  border: var(--dp-border-width-thin) solid #ffe082;
  border-radius: var(--dp-border-radius-sm);
  padding: var(--dp-spacing-md);
  margin-bottom: var(--dp-spacing-md);
}

.dp-ot__confirm-content h4 {
  margin: 0 0 var(--dp-spacing-xs);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text);
}

.dp-ot__confirm-content p {
  margin: 0 0 var(--dp-spacing-sm);
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
}

.dp-ot__copy-input {
  width: 100%;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  font-family: inherit;
  box-sizing: border-box;
  margin-bottom: var(--dp-spacing-sm);
}

.dp-ot__copy-input:focus {
  outline: none;
  border-color: var(--dp-color-primary);
}

.dp-ot__confirm-actions {
  display: flex;
  gap: var(--dp-spacing-sm);
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/OpenTemplate.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB,0BAA0B;AAC1B;EACE,aAAa;EACb,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;EACtC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gEAAgE;EAChE,mDAAmD;EACnD,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;EAC/C,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kCAAkC;EAClC,uEAAuE;EACvE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;EACzC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;EACzC,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":["/* ── Open Template ── */\n\n/* Search + Sort toolbar */\n.dp-ot__toolbar {\n  display: flex;\n  gap: var(--dp-spacing-xs);\n  margin-bottom: var(--dp-spacing-sm);\n  align-items: center;\n}\n\n.dp-ot__search-input {\n  flex: 1;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  font-family: inherit;\n  box-sizing: border-box;\n  outline: none;\n}\n\n.dp-ot__search-input:focus {\n  border-color: var(--dp-color-primary);\n}\n\n.dp-ot__sort-select {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  background: var(--dp-color-background);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.dp-ot__sort-select:focus {\n  outline: none;\n  border-color: var(--dp-color-primary);\n}\n\n/* ── Category chips ── */\n.dp-ot__categories {\n  display: flex;\n  gap: 6px;\n  margin-bottom: var(--dp-spacing-sm);\n  overflow-x: auto;\n  padding-bottom: 4px;\n  scrollbar-width: thin;\n  -ms-overflow-style: none;\n}\n\n.dp-ot__categories::-webkit-scrollbar {\n  height: 4px;\n}\n\n.dp-ot__categories::-webkit-scrollbar-thumb {\n  background: var(--dp-color-border);\n  border-radius: 2px;\n}\n\n.dp-ot__cat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-full, 9999px);\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n  white-space: nowrap;\n  background: var(--dp-color-background);\n  color: var(--dp-color-text-secondary);\n  transition: all 0.15s;\n  flex-shrink: 0;\n}\n\n.dp-ot__cat-chip:hover {\n  background: var(--dp-color-surface-hover);\n  color: var(--dp-color-text);\n}\n\n.dp-ot__cat-chip--active {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border-color: var(--dp-color-primary);\n}\n\n.dp-ot__cat-chip--active:hover {\n  background: var(--dp-color-primary-hover);\n  color: var(--dp-color-text-inverse);\n}\n\n.dp-ot__cat-chip--favorites {\n  border-color: #f9a825;\n  color: #f57f17;\n}\n\n.dp-ot__cat-chip--favorites:hover {\n  background: #fff8e1;\n}\n\n.dp-ot__cat-chip--favorites.dp-ot__cat-chip--active {\n  background: #f9a825;\n  border-color: #f9a825;\n  color: #fff;\n}\n\n.dp-ot__cat-count {\n  font-size: 10px;\n  opacity: 0.8;\n}\n\n/* ── Section headers ── */\n.dp-ot__section-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  background: #f0f3f8;\n  border-bottom: 1px solid var(--dp-color-border);\n  font-size: 11px;\n  font-weight: var(--dp-font-weight-bold);\n  color: var(--dp-color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.dp-ot__section-icon {\n  font-size: 12px;\n}\n\n/* ── Template card ── */\n.dp-ot__list {\n  display: flex;\n  flex-direction: column;\n}\n\n.dp-ot__card {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--dp-spacing-xs);\n  padding: var(--dp-spacing-sm) 10px;\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n  transition: background 0.12s;\n}\n\n.dp-ot__card:hover {\n  background: var(--dp-color-surface);\n}\n\n.dp-ot__card-fav {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px;\n  font-size: 14px;\n  line-height: 1;\n  color: var(--dp-color-border);\n  transition: color 0.15s;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.dp-ot__card-fav:hover {\n  color: #f9a825;\n}\n\n.dp-ot__card-fav--active {\n  color: #f9a825;\n}\n\n.dp-ot__card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.dp-ot__card-name {\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-bold);\n  color: var(--dp-color-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dp-ot__card-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n\n.dp-ot__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 9px;\n  font-weight: var(--dp-font-weight-bold);\n  padding: 1px 6px;\n  border-radius: var(--dp-border-radius-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n}\n\n.dp-ot__badge--category {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.dp-ot__badge--active {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dp-ot__badge--draft-status {\n  background: #f5f5f5;\n  color: #757575;\n}\n\n.dp-ot__badge--archived {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.dp-ot__badge--published {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dp-ot__badge--draft {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.dp-ot__badge--locked {\n  background: #fce4ec;\n  color: #c62828;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.dp-ot__badge--locked .dp-ot__lock-icon {\n  font-size: 10px;\n}\n\n.dp-ot__card-meta {\n  font-size: 10px;\n  color: var(--dp-color-text-secondary);\n}\n\n.dp-ot__card-actions {\n  display: flex;\n  gap: var(--dp-spacing-xs);\n  flex-shrink: 0;\n  align-items: flex-start;\n  margin-top: 2px;\n}\n\n/* ── Buttons ── */\n.dp-ot__btn {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n  transition: all 0.12s;\n}\n\n.dp-ot__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dp-ot__btn--edit {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border-color: var(--dp-color-primary);\n}\n\n.dp-ot__btn--edit:hover {\n  background: var(--dp-color-primary-hover);\n}\n\n.dp-ot__btn--copy {\n  background: var(--dp-color-surface);\n  color: var(--dp-color-primary);\n  border-color: var(--dp-color-primary);\n}\n\n.dp-ot__btn--copy:hover {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n}\n\n.dp-ot__btn--primary {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border-color: var(--dp-color-primary);\n}\n\n.dp-ot__btn--primary:hover {\n  background: var(--dp-color-primary-hover);\n}\n\n.dp-ot__btn--danger {\n  background: #c62828;\n  color: #fff;\n  border-color: #c62828;\n}\n\n.dp-ot__btn--danger:hover {\n  background: #b71c1c;\n}\n\n.dp-ot__btn--cancel {\n  background: var(--dp-color-surface);\n  color: var(--dp-color-text);\n}\n\n.dp-ot__btn--cancel:hover {\n  background: var(--dp-color-surface-hover);\n}\n\n/* ── Messages / Status ── */\n.dp-ot__error {\n  padding: var(--dp-spacing-sm);\n  background: #fde8e8;\n  color: var(--dp-color-error);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-ot__message {\n  padding: var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-ot__message--success { background: #e8f5e9; color: #2e7d32; }\n.dp-ot__message--error { background: #fde8e8; color: #c62828; }\n\n.dp-ot__loading,\n.dp-ot__empty {\n  text-align: center;\n  padding: var(--dp-spacing-lg);\n  color: var(--dp-color-text-secondary);\n  font-size: var(--dp-font-size-sm);\n}\n\n/* ── Confirmation Dialog ── */\n.dp-ot__confirm {\n  background: #fff8e1;\n  border: var(--dp-border-width-thin) solid #ffe082;\n  border-radius: var(--dp-border-radius-sm);\n  padding: var(--dp-spacing-md);\n  margin-bottom: var(--dp-spacing-md);\n}\n\n.dp-ot__confirm-content h4 {\n  margin: 0 0 var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text);\n}\n\n.dp-ot__confirm-content p {\n  margin: 0 0 var(--dp-spacing-sm);\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n}\n\n.dp-ot__copy-input {\n  width: 100%;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  font-family: inherit;\n  box-sizing: border-box;\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-ot__copy-input:focus {\n  outline: none;\n  border-color: var(--dp-color-primary);\n}\n\n.dp-ot__confirm-actions {\n  display: flex;\n  gap: var(--dp-spacing-sm);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
